import { Polyline, Placemark } from "@pbe/react-yandex-maps";
import React from "react";
import img from '../../../../assets/images/arrow-up-arrows-svgrepo-com.svg'

export const getMidPointArrow = (coordinates: number[][]) => {
  if (coordinates.length < 2) return null;
  const [start, end] = [coordinates[0], coordinates[1]];

  const mid = [
    (start[0] + end[0]) / 2,
    (start[1] + end[1]) / 2,
  ];
  const rotation = Math.atan2(end[1] - start[1], end[0] - start[0]) * (180 / Math.PI);
  return { coords: mid, rotation };
};